<template><span>Welcome to Blink</span></template>
